/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RootRoutes {
  CONF_USUARIO_NOVA_SENHA_ROUTE = '/confirmar-usuario/:hash/nova-senha',
  CONFIRMAR_USUARIO_FALHA_ROUTE = '/falha-confirmar-usuario',
  CONFIRMAR_USUARIO_ROUTE = '/confirmar-usuario/:hash',
  DESCREDITED_PROVIDER_ROUTE = '/prestadores-descredenciados',
  HEALTH_DECLARATION_CANCELATION_ROUTE = '/declaracao-saude-cancelado',
  HEALTH_DECLARATION_DYNAMIC_FORM = '/declaracao-saude/:hash/form',
  HEALTH_DECLARATION_FINALIZATION_ROUTE = '/declaracao-saude-finalizado',
  HEALTH_DECLARATION_INVALID_ROUTE = '/declaracao-saude-invalido',
  HEALTH_DECLARATION_LANDING_ROUTE = '/declaracao-saude/:hash',
  HEALTH_DECLARATION_VALID_ROUTE = '/declaracao-saude/:hash/valido',
  HEALTH_INSURANCE_ROUTE = '/portal-operadora',
  INACTIVITY_ROUTE = '/inatividade',
  LOGIN_ROUTE = '/login',
  NEW_PASSWORD_ROUTE = '/nova-senha/:hash',
  PRODUCTS_BY_USER_ROUTE = '/produtos-comercializados',
  REDIRECT_ROUTE = '/portal-operadora',
}
export { RootRoutes };
